<template>
    <div id="news" class="news">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h2>News</h2>
                </div>
            </div>
                <div id="instafetch" class="row"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'News'
    }
</script>


<style lang="scss">
    @import "../assets/styles/components/news.scss";
</style>

